import { type Theme } from '../../../theme';
import { type CSSObject } from '@emotion/react';

export const getBaseVariant = (theme: Theme): CSSObject => ({
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxSizing: 'border-box',
  border: '1px solid',
  borderColor: theme.button.primary.border,
  color: theme.button.primary.label,
  fontFamily: theme.typography.fontFamily,
  fontWeight: theme.typography.button.fontWeight,
  flex: 'auto',
  fontSize: theme.typography.button.fontSize,
  lineHeight: theme.typography.button.lineHeight,
  fontStyle: theme.typography.button.fontStyle,
  cursor: 'pointer',
  transition: 'background-color 0.15s ease-in',
});
